import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useState, useEffect } from 'react';

interface IProps {
  valueOne: string;
  title: string;
  valueTwo: string;
  onChange: (value: string) => void;
  defaultValue?: string;
  valueThree?: string;
}

export const ReportsRadio = ({
  valueOne,
  valueThree,
  valueTwo,
  onChange,
  defaultValue,
  title,
}: IProps) => {
  const [value, setValue] = useState(defaultValue || valueOne);

  useEffect(() => {
    setValue(defaultValue || valueOne);
  }, [defaultValue, valueOne]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = (event.target as HTMLInputElement).value;
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={handleChange}
        className="flex flex-col gap-[12px]"
      >
        <p className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
          {title}
        </p>
        <div>
          <FormControlLabel
            value={valueOne}
            control={<Radio />}
            label={valueOne}
          />
          <FormControlLabel
            value={valueTwo}
            control={<Radio />}
            label={valueTwo}
          />
          {valueThree && (
            <FormControlLabel
              value={valueThree}
              control={<Radio />}
              label={valueThree}
            />
          )}
        </div>
      </RadioGroup>
    </FormControl>
  );
};
